/**
 * Converts "camelCase" to "Camel Case"
 */
export function camelCaseToSpace(text: string) {
  const result = text.replace(/([A-Z])/g, ' $1');
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult.trim();
}

/**
 * Converts "snake_case" or "SNAKE_CASE to "Snake Case"
 */
export const snakeCaseToSpace = (name: string = '') =>
  name
    .split('_')
    .map((segment) => {
      if (segment === 'ID') return segment;

      return segment[0] + (segment.length > 1 ? segment.substring(1).toLowerCase() : '');
    })
    .join(' ');
